import { Box, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import React, { useEffect, useRef } from 'react'
import { TextFieldSlTp } from './SidebarPendingOrderSlTp'
import { useDebounce } from './useDebounce'
import useSlTp from './useSlTp'
import { useDefaultComponentTools } from '../../../../../hooks/useDefaultComponentTools'
import { setStateTakeProfit } from '../../../../../store/redusers/orders/actions'
import { useSelector } from 'react-redux'
import { selectTakeProfitLine } from '../../../../../store/redusers/orders/selectors'

function TpAmountComponent(
	{ userCurrency,
		takeProfitAmount,
		updateSlTp,
		setTakeProfitSend,
		takeProfitUpdate,
		assetId,
		position,
		lastPrice,
		isSuccessOpenTrade,
		setIsSuccessCreate,
		pendingPosition
	}) {

	const { dispatch, theme, t } = useDefaultComponentTools()

	const [state, action] = useSlTp(takeProfitUpdate, assetId, position, 'tp', lastPrice)
	const debouncedValue = useDebounce(state.tempValue, 500)
	const tpLine = useSelector(selectTakeProfitLine)
	const justFirstInit = useRef(false)

	useEffect(() => {
		if (updateSlTp) updateSlTp('tp', +debouncedValue)
		if (setTakeProfitSend) setTakeProfitSend(debouncedValue)
		dispatch(setStateTakeProfit(debouncedValue))
		if (+lastPrice && +lastPrice === +debouncedValue) {
			action.returnInitialState()
		}
	}, [debouncedValue])

	useEffect(() => {
		if (isSuccessOpenTrade && setIsSuccessCreate) {
			action.returnInitialState()
			setIsSuccessCreate(false)
		}
	}, [isSuccessOpenTrade])

	useEffect(() => {
		if (pendingPosition) {
			setTimeout(() => {
				if (updateSlTp) updateSlTp('tp', state.initialValue)
				if (setTakeProfitSend) setTakeProfitSend(state.initialValue)
				dispatch(setStateTakeProfit(state.initialValue))
			}, 800)
		}
	}, [state.initialValue])

	useEffect(() => {
		if(!justFirstInit.current){
			justFirstInit.current = true
			return
		}
		action.updateValueChart(tpLine)
	}, [tpLine])

	return (
		<>
			<Typography variant='px14' sx={{color: theme.palette.text.primary}}>{t('TP')}</Typography>
			<TextFieldSlTp
				// type='number'
				variant='outlined'
				onChange={action.updateValue}
				value={state.tempValue || state.initialValue || ''}
				inputProps={{ 'aria-label': 'Without label' }}
				name={'tp'}
				id='tp'
			/>
			<Box
				sx={{
					color: '#7C8DA7',
					display: 'flex',
					justifyContent: 'space-between',
					mb: 2
				}}
			>
				{!takeProfitAmount ?
					null : ((state.tempValue && state.tempValue !== '0')
					|| (state.initialValue && state.initialValue !== '0')) &&
					(<>
						<Typography sx={{color: '#7C8DA7'}}>{t('TP Amount:')}</Typography>
						<Typography sx={{color: '#7C8DA7'}}>
							{takeProfitAmount + ' ' + userCurrency}
						</Typography>
					</>)
				}
			</Box>
		</>
	)
}

TpAmountComponent.propTypes = {
	assetId: PropTypes.any,
	isSuccessOpenTrade: PropTypes.any,
	lastPrice: PropTypes.any,
	pendingPosition: PropTypes.string,
	position: PropTypes.any,
	setIsSuccessCreate: PropTypes.any,
	setStopLossSend: PropTypes.any,
	setTakeProfitSend: PropTypes.any,
	stopLossUpdate: PropTypes.any,
	takeProfitAmount: PropTypes.any,
	takeProfitUpdate: PropTypes.any,
	updateSlTp: PropTypes.any,
	userCurrency: PropTypes.any
}

export default TpAmountComponent
